// extracted by mini-css-extract-plugin
module.exports = {"team":"style_team__3nHCq","caption":"style_caption__1i2SX","teamLogo":"style_teamLogo__DFxdI","name":"style_name__ntLmx"};